(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('corporation', {
            parent: 'entity',
            url: '/corporation',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Corporations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corporation/corporations.html',
                    controller: 'CorporationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('corporation-detail', {
            parent: 'entity',
            url: '/corporation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Corporation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corporation/corporation-detail.html',
                    controller: 'CorporationDetailController',
                    controllerAs: 'vm'
                },
                'clinics@corporation-detail': {
                    templateUrl: 'app/entities/corporation/clinics.html',
                    controller: 'ClinicController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                corporation: ['$stateParams', 'Corporation', function($stateParams, Corporation) {
                    return Corporation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'corporation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('corporation-detail.edit', {
            parent: 'corporation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corporation.new', {
            parent: 'corporation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('corporation');
                });
            }]
        })
        .state('corporation.edit', {
            parent: 'corporation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corporation.delete', {
            parent: 'corporation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-delete-dialog.html',
                    controller: 'CorporationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
